import axios, { AxiosError } from 'axios'
import config from '../config/config'
import keycloak from '../Keycloak'

export const api = axios.create({
  baseURL: config.api.url,
  headers: {
    'content-type': 'application/json;charset=UTF-8'
  }
})

api.interceptors.request.use(
  function (request) {
    const accessToken = keycloak.token
    if (accessToken) {
      request.headers = {
        ...request.headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
    return request
  },
  (error) => error
)

api.interceptors.response.use(
  async (response) => {
    return response
  },
  (error: AxiosError) => {
    console.error(`Error on API call:`)
    console.error({
      method: error.config.method,
      url: error.config.url,
      data: error.config.data,
      headers: error.config.headers
    })
    const { status, data } = error.response!
    
    throw new Error(JSON.stringify(data || status || ''))
  }
)


